import { errorByCode } from "./errors";
import { db } from "./app";

export function* create(model) {
  let error;

  try {
    yield db.collection("models").add({
      createdAt: Date.now(),
      ...model,
    });
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* update(id, { folderId, patternConfig, patternId, surfaceId, userId }) {
  let error;

  try {
    yield db
      .collection("models")
      .doc(id)
      .set({
        userId,
        folderId,
        surfaceId,
        patternId,
        patternConfig,
        updatedAt: Date.now(),
      });
  } catch ({ code, message }) {
    console.log(message);
    error = errorByCode(code);
  }

  return { error };
}

export async function fetchAll({ userId }) {
  const { docs } = await db
    .collection("models")
    .where("userId", "==", userId)
    .get();

  return docs.reduce((acc, doc) => {
    acc[doc.id] = {
      id: doc.id,
      ...doc.data()
    };

    return acc;
  }, {});
}

export async function fetch({ id }) {
  let doc = await db
    .collection("models")
    .doc(id)
    .get();
  doc = doc || {};

  if (doc.exists) {
    return {
      id: doc.id,
      ...doc.data()
    };
  }
}

export async function fetchByExportToken({ token }) {
  const { docs } = await db
    .collection("models")
    .doc(token)
    .get();

  const [doc] = docs;

  if (doc) {
    return {
      id: doc.id,
      ...doc.data()
    };
  }
}

export function* destroy({ id }) {
  let error;

  try {
    yield db
      .collection("models")
      .doc(id)
      .delete();
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}



// WEBPACK FOOTER //
// ./src/services/firebase/model.js